import { useMemo } from 'react';
import { Address } from '../Address';

export default function useFormattedAddress(address: Address): string {
  return useMemo((): string => {
    let result = `${address.name}\n`;

    if (!address.id) {
      result += address.address_1.replace(/, /g, '\n');
    } else {
      result += address.address_1;

      if (address.address_2) {
        result += `\n${address.address_2}`;
      }

      result += `\n${address.postal_code} ${address.city}\n${address.country}`;
    }

    return result;
  }, [address]);
}
